import { render, staticRenderFns } from "./WelcomeWizard.vue?vue&type=template&id=604081fe&scoped=true"
import script from "./WelcomeWizard.vue?vue&type=script&lang=js"
export * from "./WelcomeWizard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeWizard.vue?vue&type=style&index=0&id=604081fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604081fe",
  null
  
)

export default component.exports